var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldStylistCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355,
    height: 164,
    viewBox: "0 0 355 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.197,
    x2: 0.966,
    y2: 0.953,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00827f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#e5d38e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00827f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-10 -1245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M20,0H335a20,20,0,0,1,20,20V144a20,20,0,0,1-20,20H20A20,20,0,0,1,0,144V20A20,20,0,0,1,20,0Z",
    transform: "translate(10 1245)",
    opacity: 0.9,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Gold_Stylist",
    "data-name": "Gold Stylist",
    transform: "translate(30 1283)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "YuGothic-Bold, Yu Gothic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gold Stylist")), /*#__PURE__*/React.createElement("text", {
    id: "Keep_90_of_what_you_make",
    "data-name": "Keep 90% of what you make",
    transform: "translate(30 1314)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "YuGothic-Bold, Yu Gothic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Keep 90% of what you make")), /*#__PURE__*/React.createElement("text", {
    id: "Keep_a_4.6_Stars_or_above_from_clients",
    "data-name": "Keep a 4.6 Stars or above from clients",
    transform: "translate(30 1361)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "YuGothic-Regular, Yu Gothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Keep a 4.6 Stars or above from clients")), /*#__PURE__*/React.createElement("text", {
    id: "Complete_35_Jobs_in_your_lifetime",
    "data-name": "Complete 35 Jobs in your lifetime",
    transform: "translate(30 1388)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "YuGothic-Regular, Yu Gothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Complete 35 Jobs in your lifetime")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M16.562,8.562a8,8,0,1,1-8-8A8,8,0,0,1,16.562,8.562ZM7.637,12.8l5.935-5.935a.516.516,0,0,0,0-.73l-.73-.73a.516.516,0,0,0-.73,0L7.272,10.244l-2.26-2.26a.516.516,0,0,0-.73,0l-.73.73a.516.516,0,0,0,0,.73L6.907,12.8a.516.516,0,0,0,.73,0Z",
    transform: "translate(328.425 1348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle-2",
    "data-name": "Icon awesome-check-circle",
    d: "M16.562,8.562a8,8,0,1,1-8-8A8,8,0,0,1,16.562,8.562ZM7.637,12.8l5.935-5.935a.516.516,0,0,0,0-.73l-.73-.73a.516.516,0,0,0-.73,0L7.272,10.244l-2.26-2.26a.516.516,0,0,0-.73,0l-.73.73a.516.516,0,0,0,0,.73L6.907,12.8a.516.516,0,0,0,.73,0Z",
    transform: "translate(328.425 1375)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStylistCard);
export default __webpack_public_path__ + "static/media/gold-stylist-card.52d790e9272ac0c50a1653bca6f9c028.svg";
export { ForwardRef as ReactComponent };